/* eslint-disable */
import React from "react";
import {
  Card,
  Group,
  Text,
  SimpleGrid,
  ThemeIcon,
  useMantineTheme,
} from "@mantine/core";
import { IconUser } from "@tabler/icons-react";
import { useGetLeaveSummary } from "api/newLeave/getAdminSummary";
import { useUser } from "hooks/useUser";

const defaultStats = [
  {
    label: "Total Present",
    value: "0",
    color: "#00C853",
    light: "#E6F9EE",
  },
  {
    label: "Pending Requests",
    value: "0",
    color: "#00C8F3",
    light: "#E6F9FF",
  },
];

export default function AdminLeaveCard() {
  const theme = useMantineTheme();
  const { user } = useUser();
  const id = user.org?._id;
  const { data, isLoading, error } = useGetLeaveSummary(id!);

  const presentuser: any = data?.totalUsers;
  const totalAllocated = Number(presentuser ?? 0);
  const totals = data?.totals;
  const totalPending = Number(totals?.totalPending ?? 0);

  const presentValue = totalAllocated;

  // Format pending requests to 2 decimal places
  const formatPendingRequests = (value: number): string => {
    if (isNaN(value) || value === 0) return "0";
    // If it's an integer (count of requests), show without decimals
    if (Number.isInteger(value)) return String(value);
    // Otherwise format to 2 decimals (should not happen for request counts, but safeguard)
    return value.toFixed(2);
  };

  const mappedStats = [
    {
      label: "Total Present",
      value: presentValue ?? defaultStats[0].value,
      color: defaultStats[0].color,
      light: defaultStats[0].light,
    },
    {
      label: "Pending Requests",
      value:
        !isNaN(totalPending) && (totalPending !== 0 || !isLoading)
          ? formatPendingRequests(totalPending)
          : defaultStats[1].value,
      color: defaultStats[1].color,
      light: defaultStats[1].light,
    },
  ];

  return (
    <div style={{ marginBottom: 12 }}>
      {/*
        SimpleGrid makes the layout responsive across breakpoints.
        Now showing 2 columns for larger screens and 1 column on small screens.
      */}
      <SimpleGrid
        cols={4}
        spacing="md"
        breakpoints={[
          { maxWidth: 900, cols: 1, spacing: "sm" }, // medium and below -> 1 column
        ]}
      >
        {mappedStats.map((item, index) => (
          <Card
            key={index}
            shadow="xs"
            radius="md"
            withBorder
            style={{
              position: "relative",
              overflow: "hidden",
              border: "1px solid #E5E7EB",
              minWidth: 0,
              minHeight: 96,
              display: "flex",
              alignItems: "center",
              padding: theme.spacing.md,
            }}
          >
            {/* Colored left accent shapes */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "40%",
                height: "100%",
                backgroundColor: item.color,
                borderTopLeftRadius: 10,
                borderBottomLeftRadius: 10,
                clipPath: "polygon(0 0, 70% 0, 100% 100%, 0% 100%)",
                zIndex: 0,
              }}
            />

            <Group position="apart" style={{ width: "100%", zIndex: 1 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 64,
                }}
              >
                <ThemeIcon
                  radius="xl"
                  size="lg"
                  style={{ backgroundColor: "white" }}
                >
                  <IconUser size={20} color={item.color} stroke={2} />
                </ThemeIcon>
              </div>

              <div style={{ flex: 1, textAlign: "right", paddingRight: 8 }}>
                <Text size="sm" color="gray" fw={500} mb={4}>
                  {item.label}
                </Text>
                <Text size="lg" fw={700} color="#0F172A">
                  {item.value}
                </Text>
              </div>
            </Group>
          </Card>
        ))}
      </SimpleGrid>
    </div>
  );
}
